import { Layout, Row, Col } from "antd";
import styled from "styled-components";

export const PageContent = styled(Layout.Content)`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  margin-top: 64px;
`;

export const PageSection = styled.div`
  padding: 42px 8%;
  display: flex;
  flex-direction: column;
`;

export const SectionHeader = styled(Row)`
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0.9px;
  color: #1070b6;
  max-width: 100%;
  .header-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
`;

export const HeaderCol = styled(Col)`
  margin-bottom: 12px;
`;

export const Container = styled(Layout)`
  height: 100%;
  width: 100%;
  background-color: inherit;
`;

export const Content = styled.div`
  margin: 0 8% 8%;
  min-height: 100%;
  flex-grow: 1;
  text-align: left;
  margin-top: 30px;
`;

export const HeadingWrapper = styled.div`
  min-height: 150px;
  background-color: #1070b6;
  color: #ffffff;
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0.9px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: left;
  padding-left: 8%;
  padding-right: 8%;
`;

export const HeadingTitle = styled.span`
  color: #ffffff;
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0.9px;
  display: block;
`;

export const Section = styled.section`
  margin-bottom: 50px;
`;

export const Sider = styled(Layout.Sider)`
  min-width: 400px !important;
  background: #00538b;
  .ant-menu {
    background: #00538b;
    .ant-menu-item {
      color: #ffffff;
      font-size: 18px;
      letter-spacing: 0.8px;
      font-weight: bold;
      margin-bottom: 16px;
      padding-left: 28px !important;
      .anticon,
      svg.svg-inline--fa {
        margin-right: 28px;
        font-weight: bold;
        font-size: 18px;
      }
    }
    .ant-menu-item:first-child {
      margin-top: 28px;
    }
    .ant-menu-item-selected {
      background-color: transparent !important;
      span {
        color: #fdd440;
      }
      .anticon,
      svg.svg-inline--fa {
        color: #fdd440;
      }
      .ant-badge-not-a-wrapper
        .ant-scroll-number-only
        > p.ant-scroll-number-only-unit {
        color: #00538b;
      }
    }
  }
`;

export const SubHeading = styled.h2`
  font-size: 24px;
  letter-spacing: 0.6px;
  color: #fdd440;
  margin-bottom: 0;
  margin-top: 40px;
  line-height: 29px;
  font-weight: bold;
`;

export const HeadingGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;
